module.exports = __webpack_public_path__ + "static/img/4.c8fa4ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/zh/4.png
// module id = Y+0W
// module chunks = 0